const createSelector = (element, options = [], selected, show = true) => {
    if (element?.parentElement) {
        if (show) {
            element.parentElement.style.display = "inline-block";
        }
        element.innerHTML = "";
    } else {
        return;
    }
    if (!options.length && element.parentElement) {
        if (window.location.href.includes("wp-admin")) {
            options[0] = "not available";
        } else {
            element.parentElement.style.display = "none";
        }
    }
    for (const name of options) {
        const option = document.createElement("option");
        option.value = name;
        option.textContent = name;
        element.appendChild(option);
        if (name === selected) {
            option.selected = true;
        }
    }
};

export default createSelector;